import { render, staticRenderFns } from "./mDashboardButtons.vue?vue&type=template&id=712afa95&scoped=true&"
import script from "./mDashboardButtons.vue?vue&type=script&lang=js&"
export * from "./mDashboardButtons.vue?vue&type=script&lang=js&"
import style0 from "./mDashboardButtons.vue?vue&type=style&index=0&id=712afa95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712afa95",
  null
  
)

export default component.exports